// ポップアップ画像のURL
document.getElementById("popUp_img").src =
	"https://cdn.shopify.com/s/files/1/0891/1657/4065/files/popup.png?v=1759133351";

// ボタン1のリンクを無効化（クーポンを受け取らない）
const link01_url = "#"; // #に変更
// ボタン2のリンクを設定（クーポンを受け取る）
const link02_url = "/pages/coupon"; // または実際のクーポンページURL

const link01 = document.getElementById("popup_link01");
const link02 = document.getElementById("popup_link02");
link01.setAttribute("href", link01_url);
link01.removeAttribute("target"); // target="_blank"を削除
link02.setAttribute("href", link02_url);

let isPopupShown = false;
let hrefToNavigate = null;
let isBackNavigation = false;
let isOpen = false; // ポップアップ表示状態を管理する変数
let referrerUrl = null; // 参照元URLを保存

// デバッグ用のログ関数
const DEBUG = true; // false に設定すればデバッグログを無効化
function debugLog(message, data = null) {
	if (DEBUG) {
		if (data) {
			console.log(`[Popup Debug] ${message}`, data);
		} else {
			console.log(`[Popup Debug] ${message}`);
		}
	}
}

// ブログ記事ページかどうかを判定する関数
function isArticlePage() {
	// Shopifyテンプレート情報を使用（theme.liquidから渡される）
	if (window.shopifyTemplate && typeof window.shopifyTemplate.isArticle !== 'undefined') {
		return window.shopifyTemplate.isArticle;
	}
	// URLパターンでも判定（フォールバック）
	const currentUrl = window.location.href;
	return currentUrl.includes('/blogs/') && currentUrl.includes('/articles/');
}

// 現在のページ情報を記録
function recordPageVisit() {
	const pageData = {
		isArticle: isArticlePage(),
		url: window.location.href,
		timestamp: Date.now()
	};
	sessionStorage.setItem('currentPageData', JSON.stringify(pageData));
	
	// 参照元URLも記録
	if (document.referrer) {
		referrerUrl = document.referrer;
		sessionStorage.setItem('referrerUrl', referrerUrl);
		debugLog('Referrer URL saved', { referrer: referrerUrl });
	}
	
	debugLog('Page visit recorded', pageData);
}

// 前のページがブログ記事だったかチェック
function wasPreviousPageArticle() {
	const previousData = sessionStorage.getItem('previousPageData');
	if (!previousData) return false;
	
	try {
		const data = JSON.parse(previousData);
		// 30秒以内の遷移であることを確認
		const timeDiff = Date.now() - data.timestamp;
		return data.isArticle && timeDiff < 30000;
	} catch (e) {
		return false;
	}
}

// 離脱確認のポップアップ表示
function showPopup(event, type, href) {
	debugLog("showPopup called", { 
		type, 
		href, 
		isOpen, 
		isArticlePage: isArticlePage(),
		wasPreviousArticle: wasPreviousPageArticle()
	});
	
	if (event) {
		event.preventDefault();
	}
	
	// ポップアップ表示条件
	let shouldShow = false;
	
	if (type === 'back') {
		// ブラウザバックの場合：前のページがブログ記事だった場合に表示
		shouldShow = wasPreviousPageArticle();
		if (shouldShow) {
			isBackNavigation = true; // ブラウザバックフラグを設定
		}
	} else {
		// 通常のトリガー（タイマー、スクロールなど）：ブログ記事ページのみ
		shouldShow = isArticlePage();
		// 通常トリガーの場合のみフラグをリセット
		if (shouldShow) {
			isBackNavigation = false; // 通常トリガーの場合はフラグをリセット
		}
	}
	
	if (!isOpen && shouldShow) {
		$(".l_popUp").fadeIn(400);
		$(".l_popUpMask").fadeIn(400);
		isPopupShown = true;
		hrefToNavigate = href;
		$("html").css("overflow", "hidden");
		isOpen = true;
		debugLog("Popup opened", { isBackNavigation, type });
	} else {
		debugLog("Popup not shown", { isOpen, shouldShow });
	}
}

// ポップアップを閉じる
function closePopup() {
	debugLog("closePopup called");
	$(".l_popUp").fadeOut(400);
	$(".l_popUpMask").fadeOut(400);
	$("html").css("overflow", "unset");
	isPopupShown = false;
	hrefToNavigate = null;
	isBackNavigation = false; // フラグをリセット
	isOpen = false;
	debugLog("Popup closed");
}

// ポップアップ閉じるボタンのクリックイベント
$(".p_popUp_close, .l_popUpMask").on("click", function () {
	let action = $(this).data("action");
	debugLog("Close button clicked", { action });

	if (action === "confirm") {
		if (isBackNavigation) {
			history.back();
		} else if (hrefToNavigate) {
			window.location.href = hrefToNavigate;
		}
	} else {
		closePopup();
	}
	$("html").css("overflow", "unset");
});

// link01（クーポンを受け取らない）のイベントリスナー
// jQueryを使用してイベントを確実にバインド
$(link01).off('click').on('click', function(e) {
	e.preventDefault();
	e.stopPropagation();
	e.stopImmediatePropagation();
	
	debugLog("Link01 (decline coupon) clicked - jQuery handler", { 
		isBackNavigation, 
		wasPreviousArticle: wasPreviousPageArticle(),
		historyLength: window.history.length,
		referrer: document.referrer,
		savedReferrer: sessionStorage.getItem('referrerUrl')
	});
	
	// ブラウザバックで表示された場合は、ポップアップを閉じるだけ
	if (isBackNavigation) {
		debugLog("Browser back navigation detected - just closing popup");
		closePopup();
		return false;
	}
	
	// 通常のトリガーで表示された場合は、前のページに戻る
	closePopup();
	
	// 戻る処理を実行
	setTimeout(() => {
		// セッションストレージから参照元URLを取得
		const savedReferrer = sessionStorage.getItem('referrerUrl');
		const previousPageData = sessionStorage.getItem('previousPageData');
		
		debugLog("Navigation decision (normal trigger)", {
			savedReferrer,
			previousPageData,
			documentReferrer: document.referrer
		});
		
		// 戻る先の優先順位
		// 1. セッションストレージに保存された参照元URL
		// 2. 前のページのURL（previousPageData）
		// 3. document.referrer
		// 4. history.back()
		
		if (savedReferrer && savedReferrer !== window.location.href) {
			debugLog("Navigating to saved referrer URL");
			window.location.href = savedReferrer;
		} else if (previousPageData) {
			try {
				const prevData = JSON.parse(previousPageData);
				if (prevData.url && prevData.url !== window.location.href) {
					debugLog("Navigating to previous page URL");
					window.location.href = prevData.url;
				} else {
					debugLog("Using history.back() - previous page same as current");
					history.back();
				}
			} catch (e) {
				debugLog("Error parsing previous page data, using history.back()");
				history.back();
			}
		} else if (document.referrer && document.referrer !== window.location.href) {
			debugLog("Navigating to document.referrer");
			window.location.href = document.referrer;
		} else if (window.history.length > 1) {
			debugLog("Using history.back()");
			history.back();
		} else {
			debugLog("No history available, going to home");
			window.location.href = '/';
		}
	}, 450);
	
	return false;
});

// link02（クーポンを受け取る）のイベントリスナー
$(link02).off('click').on('click', function (e) {
    e.preventDefault(); // デフォルトの<a>タグの動作をキャンセル（二重遷移防止）
    
    debugLog("Link02 (accept coupon) clicked");

	// ▼▼▼ GA4 イベント送信 ▼▼▼
    if (typeof gtag !== 'undefined') {
        gtag('event', 'click_coupon_popup', {
            'event_category': 'popup',
            'event_label': 'accept_coupon',
            'link_url': link02_url
        });
    } else {
        console.log('GA4 gtag is not defined'); 
    }
    
    // まずポップアップを閉じる（見た目の処理）
    closePopup();

    // 明示的に指定のURLへ遷移させる
    // わずかな遅延を入れることで、クリック時のUI反応を確実に処理してから遷移
    setTimeout(function() {
        window.location.href = link02_url;
    }, 100);
});

// スリープ検知（ブログ記事ページのみ）
(() => {
	const checkIntervalMilliseconds = 1000;
	const sleepThresholdMilliseconds = 1000;
	let lastCheckTime = Date.now();

	setInterval(() => {
		const currentTime = Date.now();
		const timeDifference = currentTime - lastCheckTime;

		if (timeDifference > checkIntervalMilliseconds + sleepThresholdMilliseconds) {
			handleSystemWakeUp();
		}
		lastCheckTime = currentTime;
	}, checkIntervalMilliseconds);

	function handleSystemWakeUp() {
		debugLog("System wake up detected");
		// ブログ記事ページの場合のみ表示
		if (!isOpen && isArticlePage()) {
			showPopup(null, "sleep"); // typeを明示
		}
	}
})();

// ブラウザバック検知の改善版
$(document).ready(function() {
	debugLog("Document ready", { isArticle: isArticlePage() });
	
	// 現在のページ情報を記録
	recordPageVisit();
	
	// ナビゲーションタイプを確認する関数
	function checkNavigationType() {
		// Performance Navigation Timing API を使用
		if (window.performance && window.performance.getEntriesByType) {
			const navEntries = window.performance.getEntriesByType("navigation");
			if (navEntries.length > 0) {
				const navTiming = navEntries[0];
				debugLog("Navigation type detected", { type: navTiming.type });
				
				// 通常のナビゲーションの場合はスキップ（ブラウザバックではない）
				if (navTiming.type === "navigate") {
					return;
				}
				
				if (navTiming.type === "back_forward") {
					debugLog("Back/Forward navigation detected via Performance API");
					
					// 前のページがブログ記事だった場合にポップアップを表示
					if (wasPreviousPageArticle()) {
						showPopup(null, "back");
					}
				}
			}
		}
		
		// フォールバック: 古いブラウザ用
		if (window.performance && window.performance.navigation) {
			const navType = window.performance.navigation.type;
			debugLog("Navigation type (legacy)", { type: navType });
			
			if (navType === 2) {
				debugLog("Back/Forward navigation detected via legacy API");
				// 前のページがブログ記事だった場合にポップアップを表示
				if (wasPreviousPageArticle()) {
					showPopup(null, "back");
				}
			}
		}
	}
	
	// ページ読み込み時にナビゲーションタイプをチェック
	checkNavigationType();
	
	// popstate イベントも併用（履歴操作の補完用）
	if (window.history && window.history.pushState) {
		// 現在のページを履歴に追加
		window.history.pushState({ page: "current", isArticle: isArticlePage() }, null, window.location.href);
		debugLog("Added current page to history");
		
		// popstateイベントリスナー（補助的な検知）
		window.addEventListener("popstate", function(event) {
			debugLog("Popstate event fired", { state: event.state });
			
			// 前のページがブログ記事だった場合にポップアップを表示
			if (!isOpen && wasPreviousPageArticle()) {
				showPopup(event, "back");
			}
		});
	}
	
	// pageshow イベント（bfcache対応）
	window.addEventListener("pageshow", function(event) {
		debugLog("Pageshow event", { 
			persisted: event.persisted,
			isArticle: isArticlePage(),
			wasPreviousArticle: wasPreviousPageArticle()
		});
		
		// bfcache（Back-Forward Cache）から復帰した場合
		if (event.persisted) {
			// 前のページがブログ記事だった場合にポップアップを表示
			if (wasPreviousPageArticle()) {
				showPopup(null, "back");
			} else {
				checkNavigationType();
			}
		}
		
		// ページ表示時は必ず現在のページ情報を記録
		recordPageVisit();
	});
	
	// pagehide イベント（ページから離れる時）
	window.addEventListener("pagehide", function(event) {
		debugLog("Pagehide event", { persisted: event.persisted });
		
		// 現在のページ情報を「前のページ」として保存
		const currentData = sessionStorage.getItem('currentPageData');
		if (currentData) {
			sessionStorage.setItem('previousPageData', currentData);
			debugLog("Saved current page as previous", JSON.parse(currentData));
		}
	});
	
	// visibilitychange イベント（ページの表示/非表示の変化を検知）
	document.addEventListener("visibilitychange", function() {
		debugLog("Visibility changed", { hidden: document.hidden });
		
		if (!document.hidden) {
			// ページが再度表示された時
			// Performance API を使って再チェック
			setTimeout(() => {
				if (window.performance && window.performance.getEntriesByType) {
					const navEntries = window.performance.getEntriesByType("navigation");
					if (navEntries.length > 0 && navEntries[0].type === "back_forward") {
						// 前のページがブログ記事だった場合にポップアップを表示
						if (!isOpen && wasPreviousPageArticle()) {
							showPopup(null, "back");
						}
					}
				}
			}, 100);
		}
	});
	
	// モバイルのスワイプジェスチャー検知（補助的）
	let touchStartX = 0;
	let touchEndX = 0;
	
	document.addEventListener("touchstart", function(e) {
		touchStartX = e.changedTouches[0].screenX;
	}, { passive: true });
	
	document.addEventListener("touchend", function(e) {
		touchEndX = e.changedTouches[0].screenX;
		handleSwipe();
	}, { passive: true });
	
	function handleSwipe() {
		const swipeThreshold = 50; // スワイプと判定する最小距離
		const swipeDistance = touchEndX - touchStartX;
		
		// 右スワイプの検知（ブラウザバックのジェスチャー）
		if (swipeDistance > swipeThreshold) {
			debugLog("Right swipe detected", { distance: swipeDistance });
		}
	}
});

// ページ離脱前の処理
window.addEventListener("beforeunload", function () {
	// 現在のページ情報を「前のページ」として保存
	const currentData = sessionStorage.getItem('currentPageData');
	if (currentData) {
		sessionStorage.setItem('previousPageData', currentData);
	}
	
	debugLog("Clearing sessionStorage on beforeunload");
});

// unload イベント（フォールバック）
window.addEventListener("unload", function () {
	// 現在のページ情報を「前のページ」として保存（フォールバック）
	const currentData = sessionStorage.getItem('currentPageData');
	if (currentData) {
		sessionStorage.setItem('previousPageData', currentData);
	}
});

// 10秒後にポップアップ表示（ブログ記事ページのみ）
setTimeout(() => {
	debugLog("10 second timer triggered");
	if (!isOpen && isArticlePage()) {
		showPopup(null, "timer"); // typeを明示
	}
}, 10000); // 10000ミリ秒 = 10秒

// 最下部までスクロールでポップアップ表示（ブログ記事ページのみ）
$(window).on("scroll.bottomDetect", function () {
	// ブログ記事ページでない場合は何もしない
	if (!isArticlePage()) {
		return;
	}
	
	// ドキュメント全体の高さを取得
	let docHeight = Math.max(
		document.body.scrollHeight,
		document.documentElement.scrollHeight,
		document.body.offsetHeight,
		document.documentElement.offsetHeight,
		document.body.clientHeight,
		document.documentElement.clientHeight
	);

	let windowHeight = window.innerHeight; // ビューポートの高さ

	let scrollTop =
		window.pageYOffset ||
		document.documentElement.scrollTop ||
		document.body.scrollTop ||
		0; // スクロール位置

	// 閾値を設定
	let threshold = 100; // 100px余裕を持たせる

	if (scrollTop + windowHeight >= docHeight - threshold && !isOpen) {
		debugLog("Bottom scroll detected");
		showPopup(null, "scroll"); // showPopupを使用してtypeを明示

		// 一度実行したらスクロールイベントを解除する
		$(window).off("scroll.bottomDetect"); // 名前空間を使うと他のscrollイベントと区別しやすい
	}
});